import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import React, { Component } from 'react';
import AssetRegistration from './AssetRegistration';
import AssetsIntelligence from './AssetsIntelligence';

export default class AssetsTabs extends Component {
  actionBegin(args: any) {
    //(args);
  }
  render() {
    return (
      <div>
        <TabComponent animation={{ next: { effect: 'None' } }}  statelessTemplates={['directiveTemplates']}>
          <TabItemsDirective>
            <TabItemDirective
              header={{ text: 'Assets' }}
              content={() => {
                return (
                  <div>
                    <AssetsIntelligence />
                  </div>
                );
              }}
            />
            <TabItemDirective
              header={{ text: 'Assets Registration' }}
              content={() => {
                return (
                  <div>
                    <AssetRegistration />
                  </div>
                );
              }}
            />
          </TabItemsDirective>
        </TabComponent>
      </div>
    );
  }
}
